export default {"src":"/_next/static/media/check-box-unchecked.7b667028.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};